<template>
<div>
  <v-text-field
    v-bind="computedProps"
    placeholder="半角英数字16文字以内"
    v-on="computedListeners">

    <template v-slot:append>
      <slot name="append"/>
      <v-btn icon color="primary" dark elevation="0" small v-if="readonly == false">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon color="primary" v-bind="attrs" @click="nippoNoSearchSync" v-on="on" tabindex="-1" dark elevation="0" small>
              <v-icon>mdi-sync</v-icon>
            </v-btn>
          </template>
          <span>入力されている日報Noの情報を表示します<br>※押下後は取得した内容で上書きされます<br>&nbsp;&nbsp;編集中の情報は保存されません。</span>
        </v-tooltip>
      </v-btn>
      <v-btn icon color="primary" dark elevation="0" small v-if="readonly == false">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon color="primary" v-bind="attrs" @click="onDialogButtonClick" v-on="on" tabindex="-1" dark elevation="0" small>
              <v-icon>mdi-magnify-plus</v-icon>
            </v-btn>
          </template>
          <span>日報検索用ポップアップを表示します<br>※日報選択後は選択した内容で上書きされます<br>&nbsp;&nbsp;編集中の情報は保存されません。</span>
        </v-tooltip>
      </v-btn>
    </template>
  </v-text-field>
  <th-nippo-no-search-dialog-v-kamotsu
    :showDialog="showDialog"
    :hatsuchiYmd="hatsuchiYmd"
    @close="onDialogClosed"/>
</div>
</template>
<script>
import controls from '@/rahmen/controls'
import validators from '@/rahmen/validators'
import inputMixin from '@/mixins/inputMixins'
import { VTextField } from 'vuetify/lib'

const ThNippoNoSearchDialogVKamotsu = () => import('./ThNippoNoSearchDialogVKamotsu.vue')

export default {
  name: 'ThNippoNoTextBoxVKamotsu',
  extends: VTextField,
  mixins: [inputMixin],
  components: {
    ThNippoNoSearchDialogVKamotsu
  },
  props: {
    /**
     * 入力タイプ
     * @see controls.InputTypes
     */
    valueType: Number,
    /**
     * 必須指定
     */
    required: Boolean,
    /**
     * 入力可能桁数
     */
    length: Number,
    /**
     * 表示エラーメッセージ
     */
    errorMessages: String,
    /**
     * 埋め込み文字
     */
    paddingChar: String,
    /**
     * 追加フォーマッタ
     */
    appendFormatter: Function,
    appendUnFormatter: Function,
    /**
     * 親画面 積日付
     */
    hatsuchiYmd: String
  },
  data: () => ({
    invalidMessage: '',
    innerValue: '',
    showDialog: false
  }),
  created () {
    this.innerValue = this.value
  },
  mounted () {
    this.invalidMessage = this.errorMessages
    console.log('mounted', this.invalidMessage, this.$el)

    if (this.invalidMessage === undefined) {
      // this[controls.VALIDATE_METHOD]()
    }
  },
  watch: {
    value: function (n, o) {
      this.innerValue = n
    }
  },
  computed: {
    computedProps () {
      return {
        ...this.$props,
        value: this.innerValue,
        maxlength: this.length,
        // ackgroundColor: this.required ? controls.Colors.Required : '',
        class: this.required ? ' required-item' : this.class,
        type: 'text',
        hideDetails: 'auto',
        outlined: !this.isReadonly,
        dense: true,
        error: this.hasError,
        errorMessages: this.invalidMessage
      }
    },
    computedListeners () {
      return {
        ...this.$listeners,
        blur: e => this.onBlur(e),
        focus: e => this.onFocus(e)
      }
    }
  },
  methods: {
    onBlur: function (e) {
      this[controls.VALIDATE_METHOD]()
      if (!this.hasError) {
        this[controls.FORMAT_METHOD]()
      }
      this.$emit('blur', e)
    },
    onFocus: function (e) {
      if (typeof this.appendUnFormatter === 'function' && this.appendUnFormatter) {
        this.innerValue = this.appendUnFormatter(this.innerValue)
      }
      const elem = this.$el.querySelector('input')
      this.$nextTick().then(() => {
        if (elem) { elem.select() }
        this.$emit('focus', e)
      })
    },
    [controls.VALIDATE_METHOD]: function () {
      const target = {
        value: this.innerValue,
        length: this.length
      }
      console.log(this)
      this.invalidMessage = undefined
      const validatorList = controls.getInputTypeValidators(this.valueType)

      if (this.required) { validatorList.unshift(validators.requireValidate) }
      if (this.appendValidators) { validatorList.push(...this.appendValidators) }

      for (let i = 0; i < validatorList.length; i++) {
        const f = validatorList[i]
        console.log(target, f.name)
        const ret = f(target)
        console.log(target, f.name, ret)
        if (ret !== undefined) {
          this.invalidMessage = ret
          // this.$set(this, 'invalidMessage', ret)
          return
        }
      }
    },
    [controls.FORMAT_METHOD]: function () {
      if (typeof this.appendFormatter === 'function' && this.appendFormatter) {
        this.innerValue = this.appendFormatter(this.innerValue)
        this.$emit('input', this.innerValue)
        console.log(controls.FORMAT_METHOD, this.innerValue)
      }
    },
    onDialogButtonClick: function (e) {
      console.log('dialog opend', this.hatsuchiYmd)
      this.showDialog = true
      console.log('dialog opend', e)
    },
    onDialogClosed: function (e) {
      console.log('dialog closed', e, this.showDialog)
      this.showDialog = false
      if (e === undefined) { return }
      this.innerValue = e.unkoJissekiNo
      this.nippoNoSearchDialogSync()
    },
    /**
     * 反映ボタン押下時イベント
     * @event input
     * @type {Event}
     * this.$emit('input', this.innerValue)
     */
    nippoNoSearchSync: function () {
      console.log(' **** XXXXX **** nippoNoSearchSync')

      this.$emit('nippoNoSearchSync', this.innerValue)
    },
    /**
     * dialog選択値inputイベント
     * @event input
     * @type {Event}
     * this.$emit('input', this.innerValue)
     */
    nippoNoSearchDialogSync: function () {
      console.log(' **** XXXXX **** nippoNoSearchDialogSync')

      this.$emit('nippoNoSearchDialogSync', this.innerValue)
    }
  }
}
</script>
<style scoped>

</style>
